import React from 'react'
import { DropdownField, ReduxFormFieldWrapper } from '@adc/ui-core'
import classNames from 'classnames/bind'
import { InvestorPreferences } from '../../../../util'
import cls from './styles.scss'
const cx = classNames.bind(cls)

const QUESTION_SETS = InvestorPreferences.IP_OBJECT()
const PRICE_INTEREST_QUESTION =
  InvestorPreferences.IP_QUESTION_CODE.INV_ONBOARDING_PRICE_INTEREST

export default ReduxFormFieldWrapper(fieldProps => {
  const {
    label = QUESTION_SETS[PRICE_INTEREST_QUESTION].label,
    className,
    elmId,
    error,
    ...rest
  } = fieldProps
  return (
    <div className={className} data-elm-id={`${elmId}_container`}>
      <span className={cx('input-label')}>{label}</span>
      <DropdownField
        {...rest}
        className={className}
        elmId={elmId}
        search={false}
        onBlur={null}
        error={error}
      />
    </div>
  )
})
